const ERROR_HTML = `
  <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;height:100vh;font-family:Roboto,sans-serif;text-align:center;padding:2rem;">
    <h1 style="color:#d32f2f;margin-bottom:1rem;">Application failed to load</h1>
    <p style="color:#666;margin-bottom:2rem;">Please try refreshing the page. If the problem persists, contact support.</p>
    <button onclick="location.reload()" style="padding:0.75rem 2rem;background:#1976d2;color:white;border:none;border-radius:4px;cursor:pointer;font-size:1rem;">
      Refresh Page
    </button>
  </div>
`;

export function showFatalError(
  error: unknown,
  phase: 'startup' | 'bootstrap',
): void {
  console.error(`[telematic-doctor] ${phase} failed:`, error);

  const appRoot = document.querySelector('td-root');
  if (appRoot) {
    appRoot.innerHTML = ERROR_HTML;
  } else {
    // Fallback: render directly to body if root element is missing
    document.body.innerHTML = ERROR_HTML;
  }
}
